import { createSlice } from '@reduxjs/toolkit';
import { fulfilled, pending, rejected, skeleton } from 'commons/constants';
import {
  getLiftStudyCreative,
  getLiftStudyCumulative,
  getLiftStudyMonthly,
  putReportEnable,
} from './report.action';
const ReportAPI = createSlice({
  name: 'report',
  initialState: {
    putReport: { ...skeleton },
    liftStudyMonthly: { ...skeleton },
    liftStudyCreative: { ...skeleton },
    liftStudyCumulative: { ...skeleton },
  },
  reducers: {
    resetReportAPI: (state) => {
      state.liftStudyMonthly = { ...skeleton };
      state.liftStudyCreative = { ...skeleton };
      state.liftStudyCumulative = { ...skeleton };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(putReportEnable.pending, (state) => {
      state.putReport.loader = pending;
    });
    builder.addCase(putReportEnable.fulfilled, (state, action) => {
      state.putReport.loader = fulfilled;
      state.putReport.data = action.payload;
    });
    builder.addCase(putReportEnable.rejected, (state, action) => {
      state.putReport.loader = rejected;
    });

    builder.addCase(getLiftStudyMonthly.pending, (state) => {
      state.liftStudyMonthly.loader = pending;
    });
    builder.addCase(getLiftStudyMonthly.fulfilled, (state, action) => {
      state.liftStudyMonthly.loader = fulfilled;
      state.liftStudyMonthly.data = action.payload;
    });
    builder.addCase(getLiftStudyMonthly.rejected, (state) => {
      state.liftStudyMonthly.loader = rejected;
    });

    builder.addCase(getLiftStudyCreative.pending, (state) => {
      state.liftStudyCreative.loader = pending;
    });
    builder.addCase(getLiftStudyCreative.fulfilled, (state, action) => {
      state.liftStudyCreative.loader = fulfilled;
      state.liftStudyCreative.data = action.payload;
    });
    builder.addCase(getLiftStudyCreative.rejected, (state) => {
      state.liftStudyCreative.loader = rejected;
    });

    builder.addCase(getLiftStudyCumulative.pending, (state) => {
      state.liftStudyCumulative.loader = pending;
    });
    builder.addCase(getLiftStudyCumulative.fulfilled, (state, action) => {
      state.liftStudyCumulative.loader = fulfilled;
      state.liftStudyCumulative.data = action.payload;
    });
    builder.addCase(getLiftStudyCumulative.rejected, (state) => {
      state.liftStudyCumulative.loader = rejected;
    });
  },
});

export const { resetReportAPI } = ReportAPI.actions;
export default ReportAPI;
